<template>
    <div class="email-item" @mouseover="hover=true" @mouseleave="hover = false">
        <span>{{ email }}</span>
        <i v-if="hover" class="el-icon-delete" @click="$emit('remove-email-from-list', email)"></i>
        <i v-else-if="emailIsValid" class="el-icon-circle-check"></i>
        <i v-else class="el-icon-circle-close"></i>
    </div>
</template>

<script>

export default {

    components: {

    },

    props: {
        email: {
            type: String,
            required: true,
        },
    },

    data (){
        return {
            hover: false,
        };
    },

    computed: {
        emailIsValid (){
            let regex =  this.$store.getters.emailRegex;
            return regex.test(this.email);
        },

    },

    mounted (){
    },

    methods: {
    },
};
</script>

<style lang="scss">
    .email-item{
        display: flex;
        justify-content: space-between;
        border: 1px solid #bbb;
        border-radius: 5px;
        line-height: 20px;
        padding: 5px;
        align-items: center;
        color: #bbb;

        i{
            font-size: 20px;
        }
        .el-icon-delete{
            cursor: pointer;
        }
        .el-icon-circle-check{
            color: #67C23A;
        }
        .el-icon-circle-close{
            color: #F56C6C;
        }
    }
    .email-item + .email-item{
        margin-top: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/partials/ListEmailValidatorVue/email-item.vue